import {
  fetchAnnouncementsTypes,
  sendAnnouncementTypes,
} from './action_types';

import {
  FETCH_ANNOUNCEMENTS_QUERY,
  SEND_ANNOUNCEMENT_MUTATION,
} from './api';

import { makeQuery, makeMutation } from '../../config/client';

export const fetchAnnouncements = variables => makeQuery(variables)(
  fetchAnnouncementsTypes,
  FETCH_ANNOUNCEMENTS_QUERY
);

export const sendAnnouncement = variables => makeMutation({ variables })(
  sendAnnouncementTypes,
  SEND_ANNOUNCEMENT_MUTATION
);



// WEBPACK FOOTER //
// ./src/modules/announcement/actions.js